import { DialogContent, Grid, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getDateFormatted } from 'shared/dates';
import { UserStatusChip } from 'components/UserStatusChip';
import { GeoEventMetadataText } from 'features/geoEvents/components/GeoEventMetadataRows';
import { RadioTowerPoi } from './PoiDialog.types';
import { EMPTY_DATA_VALUE } from '../../../../../constants';

export const RadioTowerDialogContent = (props: RadioTowerPoi): JSX.Element => {
  const { t } = useTranslation();

  const { editDate, name, channels } = props;

  const channelsList = useMemo(
    () =>
      channels.map((c) => {
        // Split the string, which combines both the channel name and tone number, into
        // two separate strings.
        const result = /^(.+)\s+((?:tone |T)\d+)$/.exec(c);
        if (result) {
          return {
            channel: result[1],
            tone: result[2],
          };
        }

        return {
          channel: c,
          tone: null,
        };
      }),
    [channels],
  );

  const editDateFormatted = editDate
    ? getDateFormatted(editDate.toISOString(), {
        includeYear: true,
      })
    : null;

  return (
    <DialogContent sx={{ padding: 2 }}>
      <Typography variant="body2" sx={{ marginBottom: 1 }}>
        <b>{name}</b>
        <UserStatusChip type="pro" sx={{ marginLeft: 1 }} />
      </Typography>
      {channelsList.map(({ channel, tone }) => (
        <Grid
          key={channel}
          container
          sx={{
            width: '100%',
            alignItems: 'baseline',
          }}
        >
          <Grid size={3}>
            <Typography variant="h4" color="secondary">
              {t('map.poi.radioTowers.channel')}
            </Typography>
          </Grid>
          <Grid size={3}>
            <Typography variant="body2">{channel}</Typography>
          </Grid>
          <Grid size={2}>
            <Typography variant="h4" color="secondary">
              {t('map.poi.radioTowers.tone')}
            </Typography>
          </Grid>
          <Grid size={2}>
            <Typography variant="body2">{tone}</Typography>
          </Grid>
        </Grid>
      ))}
      <GeoEventMetadataText sx={{ marginTop: 1 }}>
        {t('map.poi.radioTowers.updated')}
        {': '}
        {editDateFormatted || EMPTY_DATA_VALUE}
      </GeoEventMetadataText>
    </DialogContent>
  );
};
